module.exports = " <vcase></vcase> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/case/App.vue
// module id = 269
// module chunks = 6